export default __webpack_public_path__ + "static/media/icon-insights-google-preferred.7d2bf5e7.svg";